import { render, staticRenderFns } from "./vip-order.vue?vue&type=template&id=7d5f60d7&scoped=true&"
import script from "./vip-order.vue?vue&type=script&lang=js&"
export * from "./vip-order.vue?vue&type=script&lang=js&"
import style0 from "./vip-order.vue?vue&type=style&index=0&id=7d5f60d7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5f60d7",
  null
  
)

export default component.exports